import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountsModule } from './accounts/accounts.module';
import { CompanyBranchComponent } from './auth/company-branch/company-branch.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SetPasswordComponent } from './auth/set-password/set-password.component';
import { DashboardModule } from './dashboard/dashboard.module';
// import { GsaDashboardModule } from './dashboard/gsa-dashboard/gsa-dashboard.module';
import { InstantTrnsModule } from './instant-trns/instant-trns.module';
import { LayoutComponent } from './layout/layout.component';
import { OperationaltrnsModule } from './operational-trns/operational-trns.module';
import { AuthGuard } from './_guards';
import { ReportModule } from './report/report.module';
import { TrackingOutputModule } from './tracking-output/tracking-output.module';
import { OpenTrackingOutputComponent } from './tracking-output/open-tracking-output/open-tracking-output.component';
import { AuthRedirectComponent } from './auth/auth-redirect.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent, //canActivate: [AuthGuard],
    data: {
      title: 'Login'
    },
  },
  {
    path: 'login', component: LoginComponent
  },
  
  {
    path: 'open-tracking', component: OpenTrackingOutputComponent
  },
  {
    path: 'company-selection', component: CompanyBranchComponent
  },
  {
    path: 'forgetPassword', component: ForgetPasswordComponent
  },
  {
    path: 'resetPassword', component: ResetPasswordComponent
  },
  {
    path: 'setPassword', component: SetPasswordComponent
  },
  {
    path: '',
    component: AuthRedirectComponent,
    pathMatch: 'full', 
    canActivate: [AuthGuard],
    data: {
      title: 'dashboard'
    }
  },
  {
    path: '',
    component: LayoutComponent, 
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'user-management',
        data: {
          title: 'User-Management'
        },
        loadChildren: () => import('./user-management/user-management.module').then(m=>m.UserManagementModule)
      },
      {
        path: 'masters',
        data: {
          title: 'Masters'
        },
        loadChildren: () => import('./masters/masters.module').then(m=>m.MastersModule)
      },
      {
        path: 'transactions',
        data: {
          title: 'Transactions'
        },
        loadChildren: () => import('./transactions/transactions.module').then(m=>m.TransactionsModule)
      },
      {
        path: 'administration',
        data: {
          title: 'Administration'
        },
        loadChildren: () => import('./administration/administration.module').then(m=>m.AdministrationModule)
      },
      {
        path: 'operational-trns',
        loadChildren: () =>  import('./operational-trns/operational-trns.module').then(m => m.OperationaltrnsModule)
      },
      {
        path: 'instant-trns',
        loadChildren: () => import('./instant-trns/instant-trns.module').then(m => m.InstantTrnsModule)
      },
      {
        path: 'accounts',
        loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule)
      },
      {
        path: 'reports',
        data:{
          title: 'Reports'
        },
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'tracking-output',
        data:{
          title: 'Tracking Output'
        },
        loadChildren: () => import('./tracking-output/tracking-output.module').then(m => m.TrackingOutputModule)
      },
    ]
  },
  {
    path: '**',
    //In angular 12+v, we can not use redirectTo with canActivate, so we need to use a component to redirect to dashboard
    // redirectTo: 'dashboard', canActivate: [AuthGuard]
    component: AuthRedirectComponent, canActivate: [AuthGuard]  
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }